/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Total_Events_LabelInputs */



/**
* | output |
* | --- |
* | "Total Events:" |
*
* @param {Explorer_Thumbnail_Total_Events_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_total_events_label = /** @type {((inputs?: Explorer_Thumbnail_Total_Events_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Total_Events_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Total des evenements :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gesamtzahl der Ereignisse:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi totali:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Всего событий:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Total de eventos:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("活动总数：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("合計イベント数:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कुल आयोजन:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Total de eventos:")
	return /** @type {LocalizedString} */ ("Total Events:")
});